import { render, staticRenderFns } from "./TechsInfo.vue?vue&type=template&id=14f0d53a&scoped=true&"
import script from "./TechsInfo.vue?vue&type=script&lang=js&"
export * from "./TechsInfo.vue?vue&type=script&lang=js&"
import style0 from "./TechsInfo.vue?vue&type=style&index=0&id=14f0d53a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f0d53a",
  null
  
)

export default component.exports